import { supabase } from "./supabase";
import { clearLocalData } from "./db";

// 📝 REGISTER
export async function register(email, password, options = {}) {
  const cleanEmail = email.trim().toLowerCase();

  const { data, error } = await supabase.auth.signUp({
    email: cleanEmail,
    password,
    options,
  });

  if (error) throw error;

  if (!data.user) {
    return {
      status: "check_email",
      message: "Revisa tu correo para confirmar tu cuenta",
    };
  }

  return {
    status: "ok",
    user: data.user,
  };
}


// 🔐 LOGIN
// Retorna data.session (sesión activa). La validación de perfil y status
// la realiza getOrLinkProfile, llamada por DistrictProvider al recibir el evento onAuthStateChange.
export async function login(email, password) {
  const cleanEmail = email.trim().toLowerCase();

  const { data, error } = await supabase.auth.signInWithPassword({
    email: cleanEmail,
    password,
  });

  if (error) throw error;

  if (!data.user || !data.session) {
    throw new Error("No se pudo iniciar sesión");
  }

  return data.session;
}


// Keys to remove explicitly on logout (user-specific data).
// Device/app prefs are intentionally kept: keves_theme, keves:onboarding:done,
// pastoral.customLists.v1, pastoral.weeklyPlan.v1, keves_day_*.
const USER_LOCALSTORAGE_KEYS = [
  "keves_recent_searches",
  "kevia_history",
  "keves_assistant_actions_v1",
  "keves_assistant_tab_lock",
  "kevia_entity_memory",
  "kv_workflows_v1",
  "kevia_field_feedback_v1",
  "keves_pending_activity_logs",
  "keves_sync_lock",
  "keves_profile_v2",
  "keves_district_v2",
];

// Prefixes whose keys are dynamic (e.g. kevia_ems_v1_<entityId>).
const USER_LOCALSTORAGE_PREFIXES = [
  "keves_assistant_stream_cp",
  "kevia_ems_v1_",
  "kevia_rel_v1_",
  "kevia_milestones_v1_",
  "kevia_sjm_v1_",
  "keves_assistant_",
];

function clearUserLocalStorage() {
  try {
    USER_LOCALSTORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    const allKeys = Object.keys(localStorage);
    allKeys.forEach((key) => {
      if (USER_LOCALSTORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    });
  } catch {
    // Safari Private Browsing throws SecurityError — best-effort only
  }
}

// 🚪 LOGOUT
export async function logout() {
  const { error } = await supabase.auth.signOut();

  // Don't throw — signOut() can fail when server is unreachable, but Supabase
  // already clears the local session. We still need to wipe local data.
  void error;

  await clearLocalData();
  clearUserLocalStorage();
}


// 🔁 RESET PASSWORD
export async function resetPassword(email) {
  const cleanEmail = email.trim().toLowerCase();

  const { error } = await supabase.auth.resetPasswordForEmail(cleanEmail, {
    redirectTo: `${window.location.origin}/set-password`,
  });

  if (error) throw error;

  return true;
}